import type { FaireProductEntity } from "../../entity_types/product";

export const p_bqg3cucxhf: FaireProductEntity = {
  token: "p_bqg3cucxhf",
  type: "product",
  name: "Noemi Sweater - Frost",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/790cf9f75ee19087b1203dffe9e705085a6d19339ec9262fd5764a9767ce57ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f29cef1eae88c39b2ebe259265dfc582555a3db0fae62c92a2c2c5739ec1c319.jpeg",
    "https://cdn.faire.com/fastly/f575102e8cbce9d3620baf76c8be635dd2c87d15e978cc31e147e90672bc90ff.jpeg",
    "https://cdn.faire.com/fastly/2bdb9d5ffe6c84212edd7e8b72e6978a4c787226ca08100f6697c9f054cfab36.jpeg",
    "https://cdn.faire.com/fastly/c3575a90cf2099af3a2d27b2c84cf146fc8c7bfc0bb3653f25dfe47ea6e102a7.jpeg",
    "https://cdn.faire.com/fastly/dd673929ae537909c572c80b911507330f20af88d147ab0ab032228a67825b93.jpeg",
    "https://cdn.faire.com/fastly/2028b3c85b889d7a09d545cd400f25873f08a80a2096668ed0ff8c418611990e.jpeg",
    "https://cdn.faire.com/fastly/993add43a57b4bb8c30431d561dd15f78912809d8e787bb6a221308bc070871c.jpeg",
    "https://cdn.faire.com/fastly/cbcdbdd1c82290e4441c8719b8f981f3c4ea5593789f404947069163c36dd27e.jpeg"
  ],
  priceDollars: 116.1,
  description: "Plain geometric shapes placed on a wide, easy body — drawn from the postwar work of Noemi Escandell. Alpaca this fine stays light in the hand and still holds real warmth.\n\n * 89% Alpaca 11% Polyamide \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity \n * Wide, easy and a little slouchy — an easy knit pullover with an easy sleeve ",
  tags: [],
  msrpDollars: 258,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:29.985Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
